import { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from 'react-router-dom'
import HomePage from './pages/HomePage'
import BuyPage from './pages/BuyPage'
import ContactPage from './pages/ContactPage'
import SellRentPage from './pages/SellRentPage'
import ResalePage from './pages/ResalePage'
import WhatsAppFloat from './components/WhatsAppFloat'
import AIChatbot from './components/AIChatbot'
import MortgagePage from './pages/MortgagePage'
import OffplanPage from './pages/OffplanPage'
import OffplanDetailPage from './pages/OffplanDetailPage'
import PropertyDetailPage from './pages/PropertyDetailPage'
import ROICalculatorPage from './pages/ROICalculatorPage'
import ScrollToTop from './components/ScrollToTop'
import ServicePage from './pages/ServicePage'
import AdminPage from './pages/AdminPage'
import AreaIntelligencePage from './pages/AreaIntelligencePage'
import ValuationPage from './pages/ValuationPage'
import { CurrencyProvider } from './context/CurrencyContext'

// Redirects old /resale/:propertyType → /properties/buy/:propertyType
function LegacyResaleRedirect() {
  const { propertyType } = useParams()
  return <Navigate to={`/properties/buy/${propertyType}`} replace />
}

function GlobalWhatsApp() {
  const location = useLocation()
  if (location.pathname.startsWith('/mainadmin')) return null
  return <WhatsAppFloat />
}

function GlobalAIChat() {
  const location = useLocation()
  if (location.pathname.startsWith('/mainadmin')) return null
  return <AIChatbot />
}

function App() {
  useEffect(() => {
    // Inject jQuery-dependent scripts after React mounts
    const scripts = [
      '/wp-content/themes/wpresidence/public/js/bootstrap.bundle.min.js',
      '/wp-content/themes/wpresidence/public/js/bootstrap-select1.min.js',
      '/wp-content/themes/wpresidence/js/slick.min.js',
      '/wp-content/themes/wpresidence/js/control.js',
      '/wp-content/plugins/residence-buynow/buynowcontrol.js',
    ]

    // ajaxcalls_vars required by control.js
    window.ajaxcalls_vars = {
      ajaxurl: '',
      ajax_nonce: '',
      user_logged: '0',
      user_id: '0',
    }

    // control_vars required by control.js
    window.control_vars = {
      path: '/wp-content/themes/wpresidence',
      admin_url: '',
      userid: '0',
      slider_min: '0',
      slider_max: '1500000',
      curency: '$',
      where_curency: 'after',
      listings_per_row: '3',
      wp_estate_prop_unit: 'grid',
    }

    const loadedScripts = []
    scripts.forEach((src) => {
      const s = document.createElement('script')
      s.src = src
      s.async = false
      document.body.appendChild(s)
      loadedScripts.push(s)
    })

    // Elementor lazy load observer
    const lazyloadRunObserver = () => {
      const els = document.querySelectorAll('.e-con.e-parent:not(.e-lazyloaded)')
      const obs = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('e-lazyloaded')
            obs.unobserve(entry.target)
          }
        })
      }, { rootMargin: '200px 0px 200px 0px' })
      els.forEach((el) => obs.observe(el))
    }
    document.addEventListener('DOMContentLoaded', lazyloadRunObserver)
    lazyloadRunObserver()

    return () => {
      loadedScripts.forEach((s) => s.remove())
      document.removeEventListener('DOMContentLoaded', lazyloadRunObserver)
    }
  }, [])

  return (
    <CurrencyProvider>
      <BrowserRouter>
        <ScrollToTop />
        <GlobalWhatsApp />
        <GlobalAIChat />
        <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/buy" element={<BuyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/sell-rent" element={<SellRentPage />} />
        <Route path="/properties/detail/:slug/:id" element={<PropertyDetailPage />} />
        <Route path="/properties/detail/:id" element={<PropertyDetailPage />} />
        <Route path="/properties/:mode/:propertyType" element={<ResalePage />} />
        <Route path="/properties/:mode" element={<ResalePage />} />
        <Route path="/properties" element={<Navigate to="/properties/buy/residential" replace />} />
        {/* Legacy resale redirects */}
        <Route path="/resale/:propertyType" element={<LegacyResaleRedirect />} />
        <Route path="/resale" element={<Navigate to="/properties/buy/residential" replace />} />
        <Route path="/mortgage" element={<MortgagePage />} />
        <Route path="/offplan/:id" element={<OffplanDetailPage />} />
        <Route path="/offplan" element={<OffplanPage />} />
        <Route path="/roi-calculator" element={<ROICalculatorPage />} />
        <Route path="/area-intelligence" element={<AreaIntelligencePage />} />
        <Route path="/services/:id" element={<ServicePage />} />
        <Route path="/valuation" element={<ValuationPage />} />
        {/* Admin portal — standalone, no Navbar/Footer */}
        <Route path="/mainadmin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
    </CurrencyProvider>
  )
}

export default App
